import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import ImageUpload from "../commons/ImageUpload";
import Snackbar from "../commons/SnackBar";
import {
  uploadMapIcons,
  setIcon,
  getCustomMapIcons,
  deleteMapIcons,
} from "../../actions";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 4, 4),
    outline: 0,
    borderRadius: 2,
  },
  imageContainer: {
    display: "flex",
    padding: theme.spacing(5),
  },
}));

const ImageUploadModal = ({
  open,
  setOpen,
  eventId,
  seekcity,
  seekcityvisited,
  ...rest
}) => {
  const classes = useStyles();
  const [error, setError] = useState({
    show: false,
    message: "",
    severity: "warning",
  });

  console.log(eventId)

  useEffect(() => {
    rest.getCustomMapIcons(eventId);
  }, [eventId]);

  const renderModal = () => {
    if (eventId.length === 0) {
      return <Typography>
      Please save your event before uploading icons
    </Typography>
    }

    return (
      <>
        <Typography variant="h5">
          Select icons to show on the map in the app
        </Typography>
        <Typography>Only PNG files (max 100x100px) are accepted</Typography>
        <div className={classes.imageContainer}>
          <ImageUpload
            prop="seekcity"
            icon={seekcity}
            eventId={eventId}
            title="Not Yet Visited"
            setError={setError}
            remove={() =>
              rest.deleteMapIcons({
                eventId,
                name: "seekcity",
              })
            }
            save={rest.uploadMapIcons}
          />
          <ImageUpload
            prop="seekcityvisited"
            icon={seekcityvisited}
            title="Has Visited"
            setError={setError}
            remove={() =>
              rest.deleteMapIcons({
                eventId,
                name: "seekcityvisited",
              })
            }
            eventId={eventId}
            save={rest.uploadMapIcons}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Snackbar error={error} setError={setError} />
      <Modal
        className={classes.modal}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Fade in={open}>
          <Paper className={classes.paper}>{renderModal()}</Paper>
        </Fade>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ events, storage }) => {
  const {
    template: { id: eventId },
  } = events;
  const { seekcity, seekcityvisited } = storage;

  return { eventId, seekcity, seekcityvisited };
};

ImageUploadModal.defaultProps = {
  eventId: ''
}

export default connect(mapStateToProps, {
  deleteMapIcons,
  uploadMapIcons,
  setIcon,
  getCustomMapIcons,
})(ImageUploadModal);
